import { render, staticRenderFns } from "./FooterChannel.vue?vue&type=template&id=a25c6412&scoped=true"
import script from "./FooterChannel.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterChannel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FooterChannel.vue?vue&type=style&index=0&id=a25c6412&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25c6412",
  null
  
)

export default component.exports